import React, { useEffect, useRef } from "react";
import { H1 } from "app/components/Typography";
import { Avatar } from "app/components/Avatar";
import { UserData } from "../../constants";
import styles from "./styles.module.scss";

export interface WelcomeStepProps {
  onComplete: () => void;
  userData: Pick<UserData, "name" | "username" | "photoURL">;
}

export const WelcomeStep: React.FC<WelcomeStepProps> = ({
  onComplete,
  userData,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const welcomeText = userData.name
    ? `Welcome to STEEZY Studio, ${userData.name}!`
    : "Welcome to STEEZY Studio!";

  useEffect(() => {
    // Add animation class after component mounts
    if (containerRef.current) {
      containerRef.current.classList.add(styles.animate);
    }

    // Auto-advance after 1.5 seconds
    const timer = setTimeout(() => {
      onComplete();
    }, 1500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className={styles.container} ref={containerRef}>
      <div className={styles.contentContainer}>
        <Avatar
          src={userData.photoURL}
          width="250px"
          height="250px"
          alt={`${userData.name}'s profile`}
        />
        <H1 className={styles.title}>{welcomeText}</H1>
      </div>
    </div>
  );
};
